/*
 * 用法：
 * 1. 给可点击元素添加类名 `.cta-id-smooth`
 * 2. 用 `data-href` 传目标链接
 *    - 站内锚点滚动：`data-href="#discount-info"`
 *    - 带路径锚点：`data-href="/pages/chloe-kelly-sale#discount-info"`
 *    - 普通跳转：`data-href="/collections/all"`
 * 3. 可选偏移参数
 *    - `data-offset="20"`：额外减去 20px
 *    - `data-offset-section="shopify-section-header"` 或 `data-offset-section=".header-wrapper"`
 *      会自动减去对应元素高度，常用于 fixed header
 *
 * 示例：
 * <button
 *   class="cta-id-smooth"
 *   data-href="#discount-info"
 *   data-offset="12"
 *   data-offset-section=".header-wrapper"
 * >
 *   Shop now
 * </button>
 */
(function () {
  // 多个 section 可能重复引入本脚本，只绑定一次
  if (window.__ctaIdSmoothBound) return;
  window.__ctaIdSmoothBound = true;

  // 最终偏移 = data-offset + data-offset-section 对应元素高度；没填或找不到都按 0
  // data-offset-section 支持选择器，如 .site-header、#site-header；也可填纯 id
  function getOffsetSectionEl(selector) {
    try {
      var el = document.querySelector(selector);
      if (el) return el;
    } catch (e) {}

    return (
      document.getElementById(selector) ||
      document.getElementById('shopify-section-' + selector)
    );
  }

  function getCtaOffset(link) {
    var offset = parseFloat(link.getAttribute('data-offset'));
    if (isNaN(offset)) offset = 0;

    var sectionSelector = (link.getAttribute('data-offset-section') || '').trim();
    if (!sectionSelector) return offset;

    var section = getOffsetSectionEl(sectionSelector);
    if (section) offset += section.getBoundingClientRect().height;

    return offset;
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('.cta-id-smooth');
    if (!link) return;

    var href = link.getAttribute('data-href') || '';
    if (!href) return;

    event.preventDefault();

    // 链接含 #：滚到对应 id；找不到目标则走下方跳转
    if (href.indexOf('#') !== -1) {
      var id = href.split('#').pop();
      var element = id && document.getElementById(id);
      if (element) {
        var top =
          element.getBoundingClientRect().top + window.pageYOffset - getCtaOffset(link);
        window.scrollTo({
          top: top,
          behavior: 'smooth',
        });
        return;
      }
    }

    // 不含 #，或锚点不存在：直接跳转
    window.location.href = href;
  });
})();
